import type { AppMessages } from './en';

const cs: AppMessages = {
    app: {
        brand: 'Faust Signing Service',
        suite: 'Wolters Kluwer',
    },
    locale: {
        switch: 'Jazyk',
        cs: 'Čeština',
        sk: 'Slovenčina',
        en: 'English',
    },
    nav: {
        overview: 'Přehled',
        publications: 'Publikace',
        files: 'Soubory',
        queue: 'Fronta',
        users: 'Uživatelé',
        processing: 'Zpracování',
        management: 'Správa',
        monitoring: 'Monitoring',
        oauthApplications: 'OAuth aplikace',
    },
    menu: {
        overview: 'Přehled',
        publications: 'Publikace',
        files: 'Soubory',
        processing: 'Zpracování',
        pdfWatermarkDb: 'PDF vodoznak (DB)',
        epubSignDb: 'EPUB podpis (DB)',
        monitoring: 'Monitoring',
        users: 'Uživatelé',
        invitations: 'Pozvánky',
        oauthApplications: 'OAuth aplikace',
        applicationManagement: 'Správa aplikace',
        catalogSync: 'Synchronizace katalogu',
        massUpload: 'Hromadné nahrání dokumentů',
        verifyPipeline: 'Ověření pipeline',
        fingerprintCheck: 'Kontrola fingerprintu',
    },
    dashboard: {
        heroTitle: 'Přehlednější prostředí pro publikace, frontu a ověřování.',
        heroSubtitle:
            'Spravujte publikace, sledujte frontu zpracování a ověřujte výsledky podpisu z jedné konzole.',
        actionOpenQueue: 'Otevřít frontu',
        actionBrowsePublications: 'Procházet publikace',
        cards: {
            publications: {
                title: 'Publikace',
                description:
                    'Spravujte tituly a vstupní body napájející následné zpracování a ověřování.',
                action: 'Otevřít publikace',
            },
            queue: {
                title: 'Fronta',
                description: 'Sledujte průběh zpracování, chyby a poslední úlohy na jednom místě.',
                action: 'Zobrazit frontu',
            },
            files: {
                title: 'Soubory',
                description:
                    'Prohlédněte si uložené soubory, exporty a zdrojová aktiva před zpracováním.',
                action: 'Otevřít soubory',
            },
            bulkUpload: {
                title: 'Hromadné nahrání',
                description: 'Připravte a odešlete hromadná nahrání dokumentů pro PDF a EPUB tituly.',
                action: 'Spustit nahrání',
            },
            verification: {
                title: 'Ověření',
                description:
                    'Zkontrolujte celou podpisovou pipeline před zveřejněním výsledků uživatelům.',
                action: 'Spustit ověření',
            },
            fingerprint: {
                title: 'Fingerprint',
                description:
                    'Ověřte identitu dokumentu a porovnejte extrahované fingerprinty se známými záznamy.',
                action: 'Prozkoumat fingerprinty',
            },
            users: {
                title: 'Uživatelé',
                description:
                    'Udržujte operátory, pozvánky a OAuth aplikace v předvídatelném administrátorském rozhraní.',
                action: 'Spravovat uživatele',
            },
            operations: {
                title: 'Operace',
                description: 'Spouštějte synchronizaci katalogu a další provozní nástroje z jednoho místa.',
                action: 'Otevřít operace',
            },
        },
    },
    auth: {
        login: {
            subtitle: 'Přihlaste se pro pokračování do konzole',
            email: 'E-mail',
            password: 'Heslo',
            submit: 'Přihlásit se',
            submitting: 'Přihlašování…',
            invalidCredentials: 'Neplatný e-mail nebo heslo',
        },
        changePassword: {
            menuItem: 'Změnit heslo',
            titleSelf: 'Změna vašeho hesla',
            titleAdmin: 'Změna hesla uživatele %{name}',
            adminNotice: 'Měníte heslo uživatele: %{name}',
            fields: {
                oldPassword: 'Staré heslo',
                newPassword: 'Nové heslo',
                confirmPassword: 'Potvrdit heslo',
            },
            requirementsTitle: 'Požadavky na heslo:',
            requirements: {
                length: 'Alespoň 8 znaků',
                uppercase: 'Alespoň 1 velké písmeno',
                lowercase: 'Alespoň 1 malé písmeno',
                digit: 'Alespoň 1 číslice',
            },
            actions: {
                cancel: 'Zrušit',
                submit: 'Změnit heslo',
                submitting: 'Měním…',
            },
            notifications: {
                authRequired: 'Vyžadováno přihlášení',
                success: 'Heslo bylo úspěšně změněno',
                relogin: 'Přihlaste se prosím znovu pomocí nového hesla',
                failed: 'Změna hesla selhala',
            },
            errors: {
                oldPasswordRequired: 'Zadejte staré heslo',
                newPasswordRequired: 'Zadejte nové heslo',
                tooShort: 'Heslo musí mít alespoň 8 znaků',
                missingUppercase: 'Musí obsahovat velké písmeno',
                missingLowercase: 'Musí obsahovat malé písmeno',
                missingDigit: 'Musí obsahovat číslici',
                confirmRequired: 'Vyžadováno potvrzení hesla',
                mismatch: 'Hesla se neshodují',
            },
        },
        defaultUser: 'Uživatel',
    },
    actions: {
        exportCsv: 'Export do CSV',
        copyCode: 'Kopírovat kód',
        done: 'Hotovo',
        copy: 'Kopírovat',
        download: 'Stáhnout',
        refresh: 'Obnovit',
        apply: 'Použít',
        clear: 'Vyčistit',
        all: 'Vše',
    },
    notifications: {
        authRequired: 'Vyžadováno přihlášení',
        copiedToClipboard: 'Zkopírováno do schránky',
        downloadSuccess: 'Soubor úspěšně stažen',
        downloadFailed: 'Stažení souboru selhalo',
    },
    permissions: {
        noAccess: 'Nemáte oprávnění pro zobrazení této sekce.',
    },
    resources: {
        users: {
            name: 'Uživatel |||| Uživatelé',
            fields: {
                id: 'ID',
                email: 'E-mail',
                full_name: 'Jméno a příjmení',
                is_active: 'Aktivní',
                is_admin: 'Administrátor',
                created_at: 'Vytvořeno',
                updated_at: 'Upraveno',
                password: 'Heslo',
                invite_code: 'Kód pozvánky',
                role: 'Role',
            },
            filters: {
                emailPlaceholder: 'Filtr podle e-mailu',
            },
            empty: {
                title: 'Žádní uživatelé',
                hint: 'Vytvořte nového uživatele nebo někoho pozvěte.',
            },
            actions: {
                changePassword: 'Změnit heslo',
            },
            helpers: {
                passwordKeepCurrent: 'Ponechte prázdné pro zachování stávajícího hesla',
                inviteCode: 'Kód pozvánky pro tohoto uživatele',
            },
            roles: {
                admin: 'Administrátor',
                user: 'Uživatel',
            },
            notifications: {
                exportSuccess: 'Uživatelé byli úspěšně exportováni',
                exportFailed: 'Export uživatelů selhal',
                fetchFailed: 'Načtení uživatelů selhalo',
            },
        },
        invitations: {
            name: 'Pozvánka |||| Pozvánky',
            fields: {
                id: 'ID',
                email: 'E-mail',
                code: 'Kód',
                is_active: 'Aktivní',
                is_admin: 'Administrátorská oprávnění',
                invited_by: 'Pozval/a',
                created_at: 'Vytvořeno',
                expires_at: 'Vyprší',
            },
            filters: {
                emailPlaceholder: 'Filtr podle e-mailu',
            },
            empty: {
                title: 'Žádné pozvánky',
                hint: 'Vytvořte novou pozvánku tlačítkem „Vytvořit" nahoře.',
            },
            actions: {
                createInvitation: 'Vytvořit pozvánku',
            },
            notifications: {
                codeCopied: 'Kód pozvánky zkopírován do schránky',
                codeCopyFailed: 'Zkopírování kódu pozvánky selhalo',
                exportSuccess: 'Pozvánky byly úspěšně exportovány',
                exportFailed: 'Export pozvánek selhal',
                fetchFailed: 'Načtení pozvánek selhalo',
            },
            permissionDenied: {
                view: 'Nemáte oprávnění pro zobrazení pozvánek.',
                viewDetails: 'Nemáte oprávnění pro zobrazení detailu pozvánky.',
                create: 'Nemáte oprávnění pro vytváření pozvánek.',
            },
        },
        'oauth-applications': {
            name: 'OAuth aplikace |||| OAuth aplikace',
            fields: {
                name: 'Název aplikace',
                description: 'Popis',
                client_id: 'Client ID',
                client_secret: 'Client Secret',
                scopes: 'Scopes',
                is_active: 'Aktivní',
                created_at: 'Vytvořeno',
            },
            permissionDenied: {
                manage: 'OAuth aplikace mohou spravovat pouze administrátoři.',
                view: 'OAuth aplikace mohou zobrazit pouze administrátoři.',
            },
            helpers: {
                scopesCreate: 'Vyberte scope oprávnění pro aplikaci (Ctrl/Cmd pro výběr více)',
                scopesEdit: 'Ctrl/Cmd pro výběr více',
            },
            notifications: {
                created: 'OAuth aplikace byla úspěšně vytvořena',
            },
            secretDialog: {
                title: '⚠️ Uložte si OAuth přihlašovací údaje',
                alertBoldLabel: 'Důležité:',
                alertText:
                    'Toto je JEDINÁ příležitost zobrazit client secret. Uložte si jej bezpečně teď — později jej nepůjde získat zpět!',
            },
        },
        publications: {
            name: 'Publikace |||| Publikace',
            fields: {
                id: 'ID',
                sku: 'SKU',
                title: 'Název',
                description: 'Popis',
                created_at: 'Vytvořeno',
                updated_at: 'Upraveno',
            },
            filters: {
                skuPlaceholder: 'Filtr podle SKU',
                titlePlaceholder: 'Filtr podle názvu',
            },
            empty: {
                title: 'Žádné publikace',
                hint: 'Vytvořte novou publikaci tlačítkem „Vytvořit" nahoru.',
            },
            helpers: {
                skuUnique: 'Unikátní identifikátor publikace',
            },
            relatedFilesLabel: 'Soubory',
            notifications: {
                exportSuccess: 'Publikace byly úspěšně exportovány',
                exportFailed: 'Export publikací selhal',
                fetchFailed: 'Načtení publikací selhalo',
            },
        },
        files: {
            name: 'Soubor |||| Soubory',
            fields: {
                id: 'ID',
                publication_id: 'Publikace',
                file_type: 'Typ',
                filename: 'Název souboru',
                mime_type: 'MIME typ',
                size: 'Velikost',
                uploaded_by: 'Nahrál/a',
                created_at: 'Vytvořeno',
                updated_at: 'Upraveno',
            },
            filters: {
                skuPlaceholder: 'Filtr podle SKU',
                filenamePlaceholder: 'Filtr podle názvu souboru',
            },
            empty: {
                title: 'Žádné soubory',
                hint: 'Nahrajte soubor tlačítkem „Vytvořit" nahoru.',
            },
            create: {
                title: 'Nahrát soubor',
                saveLabel: 'Nahrát soubor',
                savingLabel: 'Nahrávání…',
                loadingPublications: 'Načítám publikace…',
                selectPublicationPlaceholder: 'Vyberte publikaci',
            },
            form: {
                publication: 'Publikace',
                exactSku: 'Přesné SKU',
                fileType: 'Typ souboru',
                file: 'Soubor',
                selectFileButton: 'Vybrat soubor',
            },
            helpers: {
                publication: 'Vyberte publikaci podle SKU nebo názvu, případně zadejte přesné SKU níže.',
                exactSku: 'Volitelné. Pokud je vyplněno, použije se místo vybrané publikace toto přesné SKU.',
                file: 'Podporované typy souborů: PDF, EPUB',
            },
            fileTypes: {
                pdf: 'PDF',
                epub: 'EPUB',
            },
            notifications: {
                publicationsLoadFailed: 'Načtení publikací selhalo',
                exportSuccess: 'Soubory byly úspěšně exportovány',
                exportFailed: 'Export souborů selhal',
                uploadSuccess: 'Soubor byl úspěšně nahrán',
                uploadFailedPrefix: 'Nahrání selhalo',
                selectFile: 'Vyberte soubor k nahrání',
                selectPublicationOrSku: 'Vyberte publikaci nebo zadejte přesné SKU',
                selectFileType: 'Vyberte typ souboru',
            },
        },
        queue: {
            name: 'Položka fronty |||| Položky fronty',
            fields: {
                queue_id: 'Queue ID',
                sku: 'SKU',
                processing_type: 'Typ',
                status: 'Stav',
                progress: 'Průběh',
                consumer_name: 'Jméno',
                consumer_surname: 'Příjmení',
                consumer_address: 'Adresa',
                consumer_telephone: 'Telefon',
                consumer_email: 'E-mail',
                error_code: 'Kód chyby',
                error_message: 'Zpráva chyby',
                backchannel_url: 'Backchannel URL',
                created_at: 'Vytvořeno',
                updated_at: 'Upraveno',
            },
            empty: {
                title: 'Žádné položky fronty',
                hint: 'Odešlete dokumenty ke zpracování tlačítkem „Vytvořit" nahoru.',
            },
            create: {
                title: 'Podepsat dokument',
                saveLabel: 'Odeslat k podpisu',
            },
            sections: {
                document: 'Informace o dokumentu',
                consumer: 'Informace o příjemci',
                optional: 'Volitelná nastavení',
            },
            form: {
                processingType: 'Typ zpracování',
                publicationSku: 'SKU publikace',
                firstName: 'Jméno',
                lastName: 'Příjmení',
                address: 'Adresa',
                telephone: 'Telefon',
                email: 'E-mail',
                backchannelUrl: 'Backchannel URL',
            },
            helpers: {
                backchannelUrl: 'Volitelná callback URL pro notifikace po dokončení zpracování',
            },
            processingTypes: {
                watermark: 'PDF watermark',
                sign: 'EPUB podpis',
            },
            statuses: {
                pending: 'Ve frontě',
                processing: 'Zpracovává se',
                completed: 'Dokončeno',
                error: 'Chyba',
                unknown: 'Neznámý',
            },
            actions: {
                refresh: 'Obnovit',
                download: 'Stáhnout',
            },
            notifications: {
                statusRefreshed: 'Stav obnoven',
                downloadSuccess: 'Soubor úspěšně stažen',
                downloadFailed: 'Stažení souboru selhalo',
                signFailedPrefix: 'Podpis selhal',
                queuedSuccess: 'Dokument úspěšně zařazen do fronty. Queue ID: %{queueId}',
            },
            summaryText: 'Dokument bude zpracován asynchronně. Stav můžete sledovat ve frontě.',
        },
    },
    monitoring: {
        title: 'Monitoring',
        stats: {
            total: 'Celkem',
            today: 'Dnes',
            thisWeek: 'Tento týden',
            thisMonth: 'Tento měsíc',
            doneToday: 'Dokončeno dnes',
            errorsToday: 'Chyby dnes',
        },
        charts: {
            daily: 'Denní požadavky (posledních 30 dní)',
            dailyTotal: 'Celkem',
            dailyCompleted: 'Dokončeno',
            dailyErrors: 'Chyby',
            statusDistribution: 'Rozložení stavů',
        },
        filters: {
            title: 'Filtry',
            sku: 'SKU',
            consumerEmail: 'E-mail příjemce',
            status: 'Stav',
            processingType: 'Typ zpracování',
            documentType: 'Typ dokumentu',
        },
        processingTypes: {
            watermark: 'Watermark',
            sign: 'Podpis',
        },
        documentTypes: {
            pdf: 'PDF',
            epub: 'EPUB',
        },
        table: {
            queueId: 'Queue ID',
            operator: 'Operátor',
            sku: 'SKU',
            consumerEmail: 'E-mail příjemce',
            type: 'Typ',
            doc: 'Dok.',
            status: 'Stav',
            progress: 'Průběh',
            created: 'Vytvořeno',
            completed: 'Dokončeno',
            empty: 'Žádné záznamy',
        },
        detail: {
            title: 'Detail požadavku',
            queueId: 'Queue ID',
            status: 'Stav',
            progress: 'Průběh',
            operator: 'Operátor',
            sku: 'SKU',
            consumerEmail: 'E-mail příjemce',
            processingType: 'Typ zpracování',
            documentType: 'Typ dokumentu',
            createdAt: 'Vytvořeno',
            startedAt: 'Zahájeno',
            completedAt: 'Dokončeno',
            errorCode: 'Kód chyby',
            errorMessage: 'Zpráva chyby',
            downloadProcessed: 'Stáhnout zpracovaný dokument',
        },
        notifications: {
            loadFailed: 'Načtení dat monitoringu selhalo',
            sseInterrupted: 'Spojení pro živý monitoring přerušeno',
            downloadSuccess: 'Úspěšně staženo',
            downloadFailed: 'Stažení selhalo',
        },
        tooltips: {
            refresh: 'Obnovit',
            download: 'Stáhnout',
        },
    },
    processing: {
        pdf: {
            title: 'PDF watermark (soubor z databáze)',
            heading: 'Watermark PDF z databáze',
            description: 'Vyberte publikaci a zadejte údaje příjemce pro zařazení PDF watermarku do fronty.',
            actionLabel: 'Watermark PDF',
            actionLoadingLabel: 'Zařazuji…',
            publicationHelper: 'Vyhledávejte pouze publikace, které již mají dostupný PDF soubor pro zpracování.',
            notifications: {
                queuedSuccess: 'PDF úspěšně zařazeno. Queue ID: %{queueId}',
                failedPrefix: 'Zařazení PDF watermarku selhalo',
            },
        },
        epub: {
            title: 'EPUB podpis (soubor z databáze)',
            heading: 'Podepsat EPUB z databáze',
            description: 'Vyberte publikaci a zadejte údaje příjemce pro zařazení EPUB podpisu do fronty.',
            actionLabel: 'Podepsat EPUB',
            actionLoadingLabel: 'Zařazuji…',
            publicationHelper: 'Vyhledávejte pouze publikace, které již mají dostupný EPUB soubor pro zpracování.',
            notifications: {
                queuedSuccess: 'EPUB úspěšně zařazeno. Queue ID: %{queueId}',
                failedPrefix: 'Zařazení EPUB podpisu selhalo',
            },
        },
        publicationLabel: 'Publikace',
        consumerSection: 'Informace o příjemci',
        asyncNote: 'Dokument bude zpracován asynchronně přes frontu. Průběh sledujte v Monitoringu.',
        notifications: {
            selectPublication: 'Vyberte publikaci',
            publicationsLoadFailed: 'Načtení publikací selhalo',
        },
    },
    catalog: {
        title: 'Synchronizace katalogu',
        permissionDenied: 'Přístup pouze pro administrátory.',
        sync: {
            heading: 'Synchronizace katalogu',
            description: 'Stáhne katalog z Wolters Kluwer a synchronizuje publikace v databázi.',
            actionLabel: 'Synchronizovat katalog',
            actionRunningLabel: 'Probíhá synchronizace…',
            resultsTitle: 'Výsledky synchronizace',
            progressTitle: 'Průběh synchronizace',
            completed: 'Dokončeno',
            stats: {
                total: 'Celkem: %{value}',
                created: 'Vytvořeno: %{value}',
                updated: 'Aktualizováno: %{value}',
                errors: 'Chyby: %{value}',
            },
            events: {
                tokenMissing: 'Chybí přihlašovací token. Přihlašte se prosím znovu.',
                sseInterrupted: 'SSE spojení přerušeno.',
            },
        },
        danger: {
            sectionTitle: 'Nebezpečná zóna',
            cannotBeUndone: '⚠️ Tuto akci nelze vrátit zpět',
            confirmPromptSuffix: 'pro potvrzení:',
            confirmInputLabel: 'Napište „%{word}" pro potvrzení',
            confirmInputError: 'Musí být přesně „%{word}"',
            cancel: 'Zrušit',
            deleting: 'Mažu…',
            confirmDelete: 'Potvrdit smazání',
            allFiles: {
                title: 'Smazat VŠECHNY soubory',
                description: 'Trvale smaže všechny dokumentové soubory z databáze. Publikace zůstanou v katalogu, ale nebudou mít přidružené soubory. Záznamy fronty zpracování zůstanou zachovány (reference source_file jsou vyčištěny).',
                buttonLabel: 'Smazat všechny soubory',
            },
            allPublications: {
                title: 'Smazat celý katalog',
                description: 'Trvale smaže VŠECHNY publikace včetně všech jejich souborů, fingerprintů dokumentů a verifikací fingerprintů. Záznamy fronty zpracování a audit podepsaných dokumentů zůstanou zachovány.',
                buttonLabel: 'Smazat katalog',
            },
        },
    },
    massUpload: {
        title: 'Hromadné nahrání dokumentů',
        permissionDenied: 'Přístup pouze pro administrátory.',
        heading: 'Hromadné nahrání dokumentů',
        descriptionPrefix: 'Nahrajte více PDF nebo EPUB souborů najednou. Názvy souborů musí odpovídat vzoru',
        descriptionOr: 'nebo',
        descriptionSuffix: '. Soubory s neznámými SKU budou přeskočeny. Existující soubory budou nahrazeny.',
        dropZone: {
            filesSelected: 'Vybráno souborů: %{count}',
            placeholder: 'Klikněte nebo přetáhněte soubory sem',
            accepted: 'Povoleno: .pdf, .epub',
        },
        actions: {
            upload: 'Nahrát',
            uploadCount: 'Nahrát %{count} soubor(y)',
            uploadingProgress: 'Nahrávání… (%{progress}%)',
        },
        resultsTitle: 'Výsledky nahrávání',
        progressTitle: 'Průběh nahrávání',
        completed: 'Dokončeno',
        stats: {
            total: 'Celkem: %{value}',
            created: 'Vytvořeno: %{value}',
            updated: 'Aktualizováno: %{value}',
            skipped: 'Přeskočeno: %{value}',
            errors: 'Chyby: %{value}',
        },
        events: {
            tokenMissing: 'Chybí přihlašovací token. Přihlašte se prosím znovu.',
            starting: 'Spouštím nahrávání %{count} soubor(ů)…',
            unknownResponse: 'Neznámá odpověď',
            networkError: '„%{filename}": chyba sítě — %{message}',
            summary: 'Nahrávání dokončeno — Vytvořeno: %{created}, Aktualizováno: %{updated}, Přeskočeno: %{skipped}, Chyby: %{errors}, Celkem: %{total}',
        },
    },
    verifyPage: {
        title: 'Verify Pipeline',
        permissionDenied: 'Přístup pouze pro administrátory.',
        heading: 'Verify Pipeline',
        description: 'End-to-end test: Watermark → Fingerprint → Verify → Extract → kontrola manipulace. Vyberte soubor z databáze nebo použijte testovací soubory.',
        fileSection: {
            title: 'Soubor k ověření',
            selectLabel: 'Vyberte soubor',
            loading: 'Načítání souborů…',
            placeholder: '— Vyberte soubor —',
        },
        consumerSection: {
            title: 'Zákaznické údaje',
            name: 'Jméno',
            surname: 'Příjmení',
            email: 'Email',
            address: 'Adresa',
            phone: 'Telefon',
        },
        actions: {
            start: 'Spustit verifikaci',
            running: 'Pipeline běží…',
        },
        progress: {
            stepLabel: 'Krok %{current} / %{total}',
        },
        result: {
            title: 'Výsledek verifikace',
            verified: 'OVĚŘENO ✓',
            notVerified: 'NEOVĚŘENO ✗',
            confidence: 'Confidence: %{value}%',
            bits: 'Bitů: %{value}',
            type: 'Typ: %{value}',
            original: 'Originál: %{value} KB',
            final: 'Finální: %{value} KB',
        },
        log: {
            title: 'Pipeline log',
            completedVerified: 'Dokončeno ✓',
            completed: 'Dokončeno',
            stepFormat: '── Krok %{step}: %{title} ──',
        },
        errors: {
            tokenMissing: 'Token chybí. Přihlašte se znovu.',
            sseInterrupted: 'SSE spojení přerušeno.',
        },
    },
    fingerprintVerify: {
        title: 'Ověření fingerprintu',
        permissionDenied: 'Přístup pouze pro administrátory.',
        heading: 'Ověření fingerprintu dokumentu',
        description: 'Nahrajte PDF nebo EPUB soubor a ověřte, zda obsahuje digitální fingerprint. Můžete zadat data ručně nebo porovnat s databází.',
        steps: {
            upload: '1. Nahrát soubor',
            mode: '2. Způsob ověření',
        },
        upload: {
            select: 'Vybrat soubor',
        },
        mode: {
            manual: 'Ruční ověření — zadat Queue ID a/nebo email',
            dbAll: 'Porovnat se všemi fingerprinty v databázi',
            dbSpecific: 'Porovnat s konkrétním fingerprintem z databáze',
        },
        manual: {
            queueIdLabel: 'Queue ID (volitelné)',
            emailLabel: 'Email zákazníka (volitelné)',
            queueIdPlaceholder: '550e8400-e29b-41d4-a716-...',
            emailPlaceholder: 'jan.novak@example.cz',
        },
        dbSpecific: {
            selectLabel: 'Vyberte fingerprint z databáze',
            loading: 'Načítání…',
            empty: 'Žádné fingerprinty v databázi',
            placeholder: '— Vyberte fingerprint —',
        },
        dbAll: {
            info: 'Dokument bude porovnán se všemi %{count} fingerprinty v databázi.',
        },
        actions: {
            submit: 'Ověřit fingerprint',
            submitting: 'Probíhá ověření…',
        },
        errors: {
            unexpected: 'Neočekávaná chyba',
        },
        extraction: {
            title: 'Extrakce fingerprintu',
            foundAlert: 'Fingerprint nalezen v dokumentu',
            notFoundAlert: 'Žádný fingerprint nebyl v dokumentu nalezen',
            notFoundSuffix: ' — %{reason}',
            fields: {
                method: 'Metoda',
                queueId: 'Queue ID',
                email: 'Email zákazníka',
                name: 'Jméno',
                sku: 'SKU',
                bitsExtracted: 'Bitů extrahováno',
            },
        },
        verifyResult: {
            title: 'Výsledek verifikace',
            verified: 'OVĚŘENO ✓',
            notVerified: 'NEOVĚŘENO ✗',
            confidence: 'Confidence: %{value}%',
            metaOk: 'Metadata ✓',
            metaFail: 'Metadata ✗',
            contentOk: 'Content ✓',
            contentFail: 'Content ✗',
        },
        tamper: {
            title: 'Kontrola integrity (tampering)',
            detected: 'Dokument byl pravděpodobně pozměněn po aplikaci fingerprintu!',
            notDetected: 'Dokument nejeví známky manipulace',
        },
        dbMatch: {
            title: 'Porovnání s databází',
            noFingerprint: 'V dokumentu nebyl nalezen žádný fingerprint — nelze porovnat s databází.',
            noMatches: 'Fingerprint nalezen, ale žádná shoda v databázi (0 záznamů).',
            matchesFound: 'Nalezeno %{count} shod v databázi',
            fields: {
                id: 'ID',
                email: 'Email',
                name: 'Jméno',
                sku: 'SKU',
                type: 'Typ',
                queueId: 'Queue ID',
                match: 'Shoda',
            },
            tags: {
                qidOk: 'QID ✓',
                qidFail: 'QID ✗',
                emailOk: 'Email ✓',
                emailFail: 'Email ✗',
            },
        },
    },
};

export default cs;
